// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useState, useCallback } from 'react';
import { useScrollable } from '../Scroll/usePopoverScrollable';
import { useDropdownPosition } from '../Popover/useDropdownPosition';
export function useCombobox({ comboboxRef, comboboxPopoverRef, options = [], value = null, isComboboxItemMode = false, onValueChange }) {
    const selectedValue = isComboboxItemMode && value !== null ? value.value : value;
    const selectedItem = options.find((item) => item.value === selectedValue);
    const [isOpened, setIsOpened] = useState(false);
    //#region Handlers
    const onSelect = useCallback((item) => {
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(isComboboxItemMode ? item : item.value);
        setIsOpened(false);
    }, [isComboboxItemMode, onValueChange]);
    const toggleOpen = useCallback(() => {
        setIsOpened(!isOpened);
    }, [isOpened]);
    //#endregion
    const { position: dropdownPosition, minWidth: dropdownMinWidth } = useDropdownPosition({
        anchorRef: comboboxRef,
        dropdownRef: comboboxPopoverRef,
        isActive: isOpened
    });
    useScrollable(comboboxPopoverRef, isOpened, 'y');
    return {
        isOpened,
        selectedValue,
        selectedItem,
        dropdownPosition,
        dropdownMinWidth,
        toggleOpen,
        generateKey,
        onSelect
    };
}
//#region Helper functions
function generateKey(item, index) {
    if (item.id !== undefined) {
        return item.id;
    }
    if (typeof item.value !== 'object') {
        return String(item.value);
    }
    return index;
}
//#endregion
